import { tr, useSiteLanguage } from "../../i18n/translate";
import { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';

export const ANALYTICS_CONSENT_KEY = 'salted_analytics_consent';
export const ANALYTICS_CONSENT_EVENT = 'salted-analytics-consent';
export const OPEN_COOKIE_SETTINGS_EVENT = 'salted-open-cookie-settings';

type ConsentValue = 'granted' | 'denied';

function updateGoogleConsent(value: ConsentValue) {
  window.gtag?.('consent', 'update', {
    analytics_storage: value,
    ad_storage: 'denied',
    ad_user_data: 'denied',
    ad_personalization: 'denied',
  });
  window.dispatchEvent(new CustomEvent(ANALYTICS_CONSENT_EVENT, { detail: value }));
}

export default function CookieConsent() {
  useSiteLanguage();
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const saved = window.localStorage.getItem(ANALYTICS_CONSENT_KEY) as ConsentValue | null;
    if (saved === 'granted' || saved === 'denied') {
      updateGoogleConsent(saved);
    } else {
      setVisible(true);
    }
    const openSettings = () => setVisible(true);
    window.addEventListener(OPEN_COOKIE_SETTINGS_EVENT, openSettings);
    return () => window.removeEventListener(OPEN_COOKIE_SETTINGS_EVENT, openSettings);
  }, []);

  const choose = (value: ConsentValue) => {
    window.localStorage.setItem(ANALYTICS_CONSENT_KEY, value);
    updateGoogleConsent(value);
    setVisible(false);
  };

  if (!visible) return null;

  return (
    <aside className="fixed inset-x-4 bottom-4 z-[120] mx-auto max-w-3xl rounded-2xl border border-gray-200 bg-white p-5 shadow-[0_18px_70px_rgba(15,23,42,0.18)] sm:bottom-6 sm:p-6" aria-label={tr("쿠키 사용 안내")}>
      <div className="flex flex-col gap-5 sm:flex-row sm:items-center sm:justify-between">
        <div className="max-w-xl">
          <h2 className="text-base font-semibold text-gray-950">{tr("분석 쿠키 설정")}</h2>
          <p className="mt-2 text-sm leading-6 text-gray-600">
            {tr("필수 기능은 항상 사용합니다. 동의하면 Google Analytics를 통해 방문 통계를 수집해 홈페이지를 개선합니다. 자세한 내용은")}{' '}
            <Link to="/privacy-policy" className="font-medium text-gray-900 underline underline-offset-2">{tr("개인정보처리방침")}</Link>{tr("에서 확인할 수 있습니다.")}</p>
        </div>
        <div className="flex flex-col gap-2 sm:min-w-[150px]">
          <button type="button" onClick={() => choose('granted')} className="rounded-full bg-gray-950 px-5 py-3 text-sm font-medium text-white hover:bg-gray-800">{tr("분석 쿠키 허용")}</button>
          <button type="button" onClick={() => choose('denied')} className="rounded-full border border-gray-300 px-5 py-3 text-sm font-medium text-gray-700 hover:bg-gray-50">{tr("필수 항목만")}</button>
        </div>
      </div>
    </aside>
  );
}
